import { MeetingPrepStoryRemoval as MeetingPrepStoryRemovalNode } from "@acto/gql/graphql";

export default class MeetingPrepStoryRemoval {
  constructor(
    public readonly id: string,
    public readonly clientId: string,
    public readonly storyKey: string,
  ) {}

  static fromGraphql(data: Pick<MeetingPrepStoryRemovalNode, "id" | "clientId" | "storyKey">): MeetingPrepStoryRemoval {
    return new MeetingPrepStoryRemoval(data.id, data.clientId, data.storyKey);
  }
}
